import { FC } from 'react';
import type { TradingTileData } from 'state/quotes/dashboard/model';

import { Price, ResultPanel, SolveModeLabel, StatusPanel, TileLayout } from './components';
import { StatusMessage } from './components/result/status';
import type { TileContentProps } from './Tile.common';

export const TradingTile: FC<TileContentProps<TradingTileData>> = ({ data, header, subHeader, footer }) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="warning"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        price={
          <Price
            solveResult={data.solveResult}
            solveResultFormat={data.solveResultFormat}
            xMargin={data.xMargin}
            color="warning"
          />
        }
        statusPanel={
          <StatusPanel className="alert alert-discreet-warning">
            <StatusMessage msgKey="dashboard.trading" icon="hourglass_empty" />
          </StatusPanel>
        }
      />
    </TileLayout>
  );
};

TradingTile.displayName = 'TradingTile';
